"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const React = tslib_1.__importStar(require("react"));
const useHoustonTheme_1 = tslib_1.__importDefault(require("@eduzz/houston-styles/useHoustonTheme"));
const __1 = tslib_1.__importDefault(require(".."));
const useMediaQuery_1 = tslib_1.__importDefault(require("../../hooks/useMediaQuery"));
const defaultSizesMap = {
    h1: 'giant',
    h2: 'xxxl',
    h3: 'xxl',
    h4: 'lg',
    h5: 'md',
    h6: 'xs',
    display: 'giant',
    xl: 'xxxl',
    lg: 'xxl',
    md: 'lg',
    sm: 'md',
    xs: 'xs'
};
const mobileSizesMap = {
    h1: 'xxxl',
    h2: 'xxl',
    h3: 'lg',
    h4: 'md',
    h5: 'sm',
    h6: 'xs',
    display: 'xxxl',
    xl: 'xxl',
    lg: 'lg',
    md: 'md',
    sm: 'sm',
    xs: 'xs'
};
const weightsMap = {
    h1: 'regular',
    h2: 'regular',
    h3: 'semibold',
    h4: 'semibold',
    h5: 'semibold',
    h6: 'bold',
    display: 'regular',
    xl: 'regular',
    lg: 'semibold',
    md: 'semibold',
    sm: 'semibold',
    xs: 'bold'
};
const Heading = React.forwardRef((_a, ref) => {
    var { as = 'h1', children, size: sizeProp } = _a, props = tslib_1.__rest(_a, ["as", "children", "size"]);
    const { breakpoints } = (0, useHoustonTheme_1.default)();
    const isMobile = (0, useMediaQuery_1.default)(breakpoints.down('sm'));
    const sizesMap = isMobile ? mobileSizesMap : defaultSizesMap;
    const fontSize = sizeProp ? sizesMap[sizeProp] : sizesMap[as];
    const fontWeight = sizeProp ? weightsMap[sizeProp] : weightsMap[as];
    return ((0, jsx_runtime_1.jsx)(__1.default, Object.assign({ as: as, ref: ref, size: fontSize, weight: fontWeight }, props, { children: children })));
});
exports.default = Heading;
